import { Routes } from "@angular/router";
import { authorizedGuard } from "./core/auth/guards/authorized.guard";
import { ComponentRoutes } from "./core/routing/component-routes";

export const routes: Routes = [
    { path: "", redirectTo: ComponentRoutes.gameConfigs.root, pathMatch: "full" },
    {
        path: ComponentRoutes.auth.root,
        loadComponent: () => import("./core/auth/pages/sign-in-page/sign-in-page.component").then(x => x.SignInPageComponent),
    },
    {
        path: ComponentRoutes.users.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/users/users.routes").then(x => x.usersRoutes),
    },
    {
        path: ComponentRoutes.cheaters.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/cheaters/cheaters.routes").then(x => x.cheatersRoutes),
    },
    {
        path: ComponentRoutes.gameConfigs.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/game-configs/game-configs.routes").then(x => x.gameConfigsRoutes),
    },
    {
        path: ComponentRoutes.virtualServers.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/servers-config/servers-config.routes").then(x => x.virtualServersRoutes),
    },
    {
        path: ComponentRoutes.backofficeUsers.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/backoffice-users/backoffice-users.routes").then(x => x.backofficeUsersRoutes),
    },
    {
        path: ComponentRoutes.permissions.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/backoffice-users/backoffice-users.routes").then(x => x.permissionsRoutes),
    },
    {
        path: ComponentRoutes.gameEvents.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/game-events/game-events.routes").then(x => x.gameEventsRoutes),
    },
    {
        path: ComponentRoutes.inbox.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/inbox/inbox.routes").then(x => x.inboxRoutes),
    },
    {
        path: ComponentRoutes.serverLoad.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/server-load/server-load.routes").then(x => x.serverLoadRoutes),
    },
    {
        path: ComponentRoutes.aiModeration.root,
        canActivate: [authorizedGuard],
        loadChildren: () => import("./features/ai-moderation/ai-moderation.routes").then(x => x.aiModerationRoutes),
    },
];
